import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getInitialLocale } from './utils';

// English resources — imported for TypeScript type inference via declaration merging
import enCommon from '../locales/en/common.json';
import enErrors from '../locales/en/errors.json';
import enForms from '../locales/en/forms.json';
import enBadges from '../locales/en/badges.json';
import enNavigation from '../locales/en/navigation.json';
import enPages from '../locales/en/pages.json';

import deCommon from '../locales/de/common.json';
import deErrors from '../locales/de/errors.json';
import deForms from '../locales/de/forms.json';
import deBadges from '../locales/de/badges.json';
import deNavigation from '../locales/de/navigation.json';
import dePages from '../locales/de/pages.json';

import bgCommon from '../locales/bg/common.json';
import bgErrors from '../locales/bg/errors.json';
import bgForms from '../locales/bg/forms.json';
import bgBadges from '../locales/bg/badges.json';
import bgNavigation from '../locales/bg/navigation.json';
import bgPages from '../locales/bg/pages.json';

export const defaultNS = 'common' as const;

export const resources = {
  en: {
    common: enCommon,
    errors: enErrors,
    forms: enForms,
    badges: enBadges,
    navigation: enNavigation,
    pages: enPages,
  },
  de: {
    common: deCommon,
    errors: deErrors,
    forms: deForms,
    badges: deBadges,
    navigation: deNavigation,
    pages: dePages,
  },
  bg: {
    common: bgCommon,
    errors: bgErrors,
    forms: bgForms,
    badges: bgBadges,
    navigation: bgNavigation,
    pages: bgPages,
  },
} as const;

i18next.use(initReactI18next).init({
  lng: getInitialLocale(),
  fallbackLng: 'en',
  ns: ['common', 'errors', 'forms', 'badges', 'navigation', 'pages'],
  defaultNS,
  resources,
  interpolation: {
    // React escapes values by default — no need for i18next to double-escape
    escapeValue: false,
  },
  returnEmptyString: false,
  returnNull: false,
  ...(import.meta.env.DEV && {
    missingKeyHandler: (lngs: readonly string[], ns: string, key: string) => {
      console.warn(`[i18n] missing key: ${ns}:${key} for languages: ${lngs.join(', ')}`);
    },
    saveMissing: true,
  }),
});

export { i18next as i18n };
